import React from 'react';
import useIsMobile from '../../../../hooks/useIsMobile';
import ApplicationField from '../../ApplicationField/ApplicationField';
import { ApplicationErrors, ApplicationPersonalDetails } from '../../helpers/validateApplication';

type PersonalDetailsProps = {
  details: ApplicationPersonalDetails;
  errors: ApplicationErrors;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  showEmailTooltip: boolean;
};

export default function PersonalDetails({ details, errors, onChange, showEmailTooltip }: PersonalDetailsProps) {
  const isMobile = useIsMobile();

  return (
    <>
      <ApplicationField
        id="name"
        name="name"
        label="Name"
        required
        placeholder={isMobile ? 'Jan doe' : 'Jan Doe'}
        autoComplete="name"
        value={details.name}
        onChange={onChange}
        error={errors.name}
      />
      <ApplicationField
        id="email"
        name="email"
        type="email"
        label="Email"
        required
        labelTooltip={showEmailTooltip ? 'We use this email for payment' : undefined}
        placeholder="jandoe@email.com"
        autoComplete="email"
        value={details.email}
        onChange={onChange}
        error={errors.email}
      />
      <ApplicationField
        id="instagramUsername"
        name="instagramUsername"
        label="Instagram handle"
        required
        placeholder={isMobile ? '@yourhandle' : '@jandoe123'}
        autoCapitalize="none"
        autoCorrect="off"
        value={details.instagramUsername}
        onChange={onChange}
        error={errors.instagramUsername}
      />
    </>
  );
}
